import type { FormEvent } from 'react';
import type { IntakeDetail } from '../shared/types';
import { NameInput } from './NameInput';
import { NewIntakeDelivery } from './NewIntakeDelivery';
import { consultationInputToIso } from '../shared/consultationTime';
import { CollapsiblePanel } from './CollapsiblePanel';

function ConsultationInput() {
	return (
		<label>
			Initial Consultation — date and time (optional)
			<input
				name="consultationAt"
				type="datetime-local"
				onChange={(event) => {
					try {
						consultationInputToIso(event.currentTarget.value);
						event.currentTarget.setCustomValidity('');
					} catch (error) {
						event.currentTarget.setCustomValidity(error instanceof Error ? error.message : 'Select a valid date and time.');
					}
				}}
			/>
			<small>Eastern Time (New York). Email reminder will be sent 24 hours before the appointment.</small>
		</label>
	);
}

export function NewIntakeForm({
	onSubmit,
	disabled,
	smsEnabled,
}: {
	onSubmit: (event: FormEvent<HTMLFormElement>) => Promise<void>;
	disabled: boolean;
	smsEnabled: boolean;
}) {
	return (
		<CollapsiblePanel title="New intake">
			{disabled && <p>Intake creation is temporarily disabled by an administrator.</p>}
			<form onSubmit={(event) => void onSubmit(event)} className="compact-form">
				<label>
					Client name
					<NameInput name="clientDisplayName" required />
				</label>
				<label>
					Email
					<input name="clientEmail" type="email" />
				</label>
				<label>
					Mobile number
					<input name="clientMobile" type="tel" />
				</label>
				<ConsultationInput />
				<label>
					Reminder language
					<select name="reminderLanguage" defaultValue="en">
						<option value="en">English</option>
						<option value="ru">Russian</option>
						<option value="both">English and Russian</option>
					</select>
				</label>
				<label>
					Second client or spouse
					<NameInput name="secondClientName" />
				</label>
				<label>
					MyCase reference
					<input name="matterReference" />
				</label>
				<NewIntakeDelivery smsEnabled={smsEnabled} />
				<div className="button-row">
					<button type="submit" name="action" value="draft" className="secondary" disabled={disabled}>
						Create without sending
					</button>
					<button type="submit" name="action" value="send" disabled={disabled}>
						Create and send
					</button>
				</div>
			</form>
		</CollapsiblePanel>
	);
}

export function IntakeSettingsForm({
	intake,
	onSave,
}: {
	intake: Pick<IntakeDetail, 'reminderLanguage'>;
	onSave: (input: { reminderLanguage: 'en' | 'ru' | 'both' }) => Promise<void>;
}) {
	return (
		<form
			className="compact-form"
			onSubmit={(event) => {
				event.preventDefault();
				const data = new FormData(event.currentTarget);
				void onSave({
					reminderLanguage: String(data.get('reminderLanguage')) as 'en' | 'ru' | 'both',
				});
			}}
		>
			<label>
				Reminder language
				<select name="reminderLanguage" defaultValue={intake.reminderLanguage}>
					<option value="en">English</option>
					<option value="ru">Russian</option>
					<option value="both">English and Russian</option>
				</select>
			</label>
			<button type="submit">Save preferences</button>
		</form>
	);
}
